import { FormEvent, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { useLogin } from '../../api/auth'
import { authTokenState, isLoggedInState } from '../../atoms/user'
import Button from '@mui/material/Button'
import Input from '../common/Input'

interface Props {
  className?: string
}

export default function LoginForm({ className }: Props) {
  const login = useLogin()
  const phoneNumberRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)
  const navigate = useNavigate()
  const setIsLoggedIn = useSetRecoilState(isLoggedInState)
  const setAuthToken = useSetRecoilState(authTokenState)

  async function submitForm(e: FormEvent) {
    e.preventDefault()
    await login.mutateAsync({
      password: passwordRef.current?.value,
      phoneNumber: '+98' + phoneNumberRef.current?.value?.slice(1),
    })
  }

  useEffect(() => {
    if (login.isSuccess) {
      setIsLoggedIn(login.isSuccess)
      setAuthToken(login.data.data)
      navigate('/')
    }
  }, [login.isSuccess])

  return (
    <div className={`rounded-md border-2 border-slate-300 p-5 ${className}`}>
      <form onSubmit={submitForm}>
        <div className="py-2 w-full">
          <Input
            placeholder="شماره تلفن"
            type="tel"
            innerRef={phoneNumberRef}
            error={login.isError}
            autoComplete="username"
          />
        </div>
        <div className="py-2">
          <Input
            placeholder="رمز عبور"
            type="password"
            error={login.isError}
            innerRef={passwordRef}
            autoComplete="current-password"
          />
        </div>
        <Button fullWidth variant="contained" sx={{ mt: 3 }} onClick={submitForm}>
          ورود
        </Button>
      </form>
    </div>
  )
}
